import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/main',
      name: 'home',
      component: () => import('@/views/home/home'),
      meta: {
        keepAlive: true,
        showTab: true,
        active: 'home'
      }
    },
    {
      path: '/',
      name: 'main',
      component: () => import('@/views/home/home'),
      meta: {
        showTab: true,
        active: 'home',
        keepAlive: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/home'),
      meta: {
        keepAlive: true,
        showTab: true,
        active: 'home'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/user/user'),
      meta: {
        keepAlive: true,
        showTab: true,
        active: 'user'
      }
    },
    {
      path: '/micro_detail',
      name: 'micro_detail',
      component: () => import('@/views/micro/detail'),
      meta: {
        logo2: true,
        logo3: true,
        isHome: true,
        homeTitle: '更多微课',
        homeUrl: '/wxapp/#/?enterprise_id=-1&link_id=1&account=',
        keepAlive: true,
        title: '微课详情'
      }
    },
    {
      path: '/point_type',
      name: 'point_type',
      component: () => import('@/views/point/type'),
      meta: {
        keepAlive: true,
        title: '选择知识点'
      }
    },
    {
      path: '/point_class',
      name: 'point_class',
      component: () => import('@/views/point/class'),
      meta: {
        keepAlive: true,
        title: '选择难度'
      }
    },
    {
      path: '/topic',
      name: 'topic',
      component: () => import('@/views/point/topic'),
      meta: {
        keepAlive: true,
        title: '测评'
      }
    },
    {
      path: '/point_detail',
      name: 'point_detail',
      component: () => import('@/views/point/detail'),
      meta: {
        keepAlive: true,
        title: '测评简介'
      }
    },
    {
      path: '/point_detail2',
      name: 'point_detail2',
      component: () => import('@/views/point/detail'),
      meta: {
        keepAlive: true,
        title: '测评简介',
        isHome: true,
        logo3: true,
        homeTitle: '更多测评',
        homeUrl: '/main?qrcode_id=-1'
      }
    },
    {
      path: '/outcome',
      name: 'outcome',
      component: () => import('@/views/point/outcome'),
      meta: {
        keepAlive: true,
        title: '测评列表'
      }
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('@/views/point/report'),
      meta: {
        keepAlive: true,
        title: '测评结果'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js